import { colorMap } from '../constants/colors';
import { FormattedLotteryResult, LotteryApiResult } from '../interfaces/lotto.interface';

export const formatLotteryResult = (data: LotteryApiResult[]): FormattedLotteryResult[] => {
    return data.map((item: LotteryApiResult) => {
      const numbers: number[] = item.numberResult.split("-").map(Number);
      const colors: string[] = item.colorResult.split("-").map((color: string) => colorMap[color]);
  
      return {
        code: item.code,
        lotteryCode: item.lotteryCode,
        fullDate: item.fullDate,
        date: item.date,
        time: item.time,
        gameLotteryStatus: item.gameLotteryStatus,
        result: numbers.map((number, index) => ({
          colorCode: colors[index],
          number: number,
        })),
        resultSum: item.resultSum,
      };
    });
  };

 export function getMillisecondsDifference(closeDate: Date): number {
    const currentTime = new Date();
  
    const millisecondsDifference = closeDate.getTime() - currentTime.getTime();
  
    return millisecondsDifference;
  }


 export function getCurrentTimeIn12HourFormat(currentDate: Date) {
    let hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    hours = hours % 12;
    hours = hours ? hours : 12;
  
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;
  
    return `${hours}:${minutesStr} ${ampm}`;
  }

  export function parseTimeToDate(timeStr: string) {
    if (!timeStr || typeof timeStr !== 'string') {
      throw new Error('Invalid time string');
    }
  
    const [time, modifier] = timeStr.split(' '); 
    if (!time || !modifier) {
      throw new Error('Invalid time format');
    }
  
    let [hours, minutes] = time.split(':').map(Number); 
  
    if (modifier === 'PM' && hours !== 12) {
      hours += 12; 
    }
    if (modifier === 'AM' && hours === 12) {
      hours = 0; 
    }
  
    const date = new Date();
    date.setHours(hours, minutes, 0, 0); 
  
    return date;
  }